(function($){
    // JS
    window.Loading = {

        // Set a cookie for the language selected
        //======================================================================
        loading: function()
        {
            $(document).ready(function(){

                

                $(document).on('click', '[data-js-language]', function(e){
                    e.preventDefault();
                    var cookieVal = $(this).data('js-language');

                    setCookie('lang', cookieVal, 365);
                    // redirect(cookie);
                    // console.log(cookie);

                });
            });
            
        }
        
    }

var cookie = getCookie('lang');
                redirect(cookie); 

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function redirect(cookie) {

        if(cookie == 'en-us') {
            window.location = '/en-us';
            return;
        } 
        else if(cookie == 'en-eu') {
            window.location = '/en-eu';
        } 
        else {
            //window.location = '/';
        }
        return;
    }

    // Run
    $(function(){
        //Loading.loading();
    });


}(jQuery));